import { supabase } from '@/lib/supabase'

export async function fetchStoreNames(): Promise<string[]> {
  const { data, error } = await supabase.rpc('distinct_store_names')

  if (error) throw new Error(error.message)
  return (data || []).map((r) => r.store_name)
}

export async function fetchItemNames(): Promise<string[]> {
  const { data, error } = await supabase.rpc('distinct_item_names')

  if (error) throw new Error(error.message)
  return (data || []).map((r) => r.name)
}
